import { toAirshipVariableKey } from "@hightouch/lib/customer-data/decision-engine/destination-definitions/airship-variable-key";
import type { DecisionEngineDestinationUI } from "./definition";

const VARIABLE_REFERENCE_PREFIX = "hightouch.recommendation.variables.";

export const airshipUI: DecisionEngineDestinationUI = {
  campaignSetup: "resource",
  resourceName: "push template",
  channelDescription: "Airship",
  getReferenceString: (reference) => {
    const name = reference.startsWith(VARIABLE_REFERENCE_PREFIX)
      ? reference.slice(VARIABLE_REFERENCE_PREFIX.length)
      : reference;
    return `{{${toAirshipVariableKey(name)}}}`;
  },
  isInactive: () => false,
  isPreviewSupported: true,
  getTemplateResourceType: () => "push-template",
  getResourceType: () => "push-template",
  isTestSendSupported: true,
  showIdentifierField: true,
};
